import { useContext } from 'react';
import { useDrag } from 'react-dnd';
import DragContext from '../../context/DragContext';

function ProductChip({ product, onRemove }) {
  const setIsDragging = useContext(DragContext);

  const [{ isDragging }, drag] = useDrag({
    type: 'product',
    item: () => {
      setIsDragging(true);
      return {
        type: 'product',
        id: product.retailer_sku_id || product.id,
        originalPrice: product.regular_price || product.original_price || product.originalPrice,
        promoStartDate: product.promo_start_date,
        promoEndDate: product.promo_end_date,
        promoType: product.promo_type || product.promoType,
        retailerSkuId: product.retailer_sku_id || product.id,
        variantId: product.variant_id,
        promoPrice: product.sale_price || product.promo_price || product.promoPrice,
        inventory: product.inventory,
        cleanedImgLargeSrc: product.cleaned_img_large_src || product.original_img_large_src || product.img_large_src || product.image_url || product.cleanedImgLargeSrc,
        cleanedImgSmallSrc: product.cleaned_img_small_src || product.cleanedImgSmallSrc,
        originalImgLargeSrc: product.original_img_large_src || product.img_large_src || product.image_url || product.originalImgLargeSrc,
        name: product.product_name || product.name,
        productDescription: product.product_description || product.productDescription,
        category: product.category,
        subCategory1: product.sub_category_1,
        subCategory2: product.sub_category_2,
        subCategory3: product.sub_category_3,
        brand: product.brand,
        limit_qty: product.limit_qty,
        priceUnit: product.price_unit || product.priceUnit
      };
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
    end: () => {
      setIsDragging(false);
    },
  });

  const displayName = product.product_name || product.name || 'Unknown';
  const displayPrice = product.sale_price || product.promo_price || product.promoPrice || product.regular_price || product.original_price || product.originalPrice;

  return (
    <div
      ref={drag}
      className="product-chip"
      style={{ opacity: isDragging ? 0.5 : 1 }}
      title={displayName}
    >
      <span className="product-chip-name">{displayName}</span>
      {displayPrice && (
        <span className="product-chip-price">${displayPrice}</span>
      )}
      <button
        className="product-chip-remove"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        title="Remove from staging"
      >
        &times;
      </button>
    </div>
  );
}

export default ProductChip;
